
import { memo, useState } from 'react';
import { IHoraSedeCustomDTO, IHoraSedeDTO, IHoraSedeFullDTO } from "../../models/happy-code-api.model";
import MsgInfoSistema from '../../components/MsgInfoSistema';
import info from '../../assets/img/financeiro-info/info.svg';

interface CampoHoraSede<T> {
    key: keyof T;
    label: string;
    render?: (value: any, row?: T) => React.ReactNode;
  }

interface TItemLista {
    hora: IHoraSedeFullDTO | IHoraSedeCustomDTO;
    handleCampanha: (hora: IHoraSedeFullDTO | IHoraSedeCustomDTO, state: boolean) => void;
}


const ItemListHoraSede = memo(({ hora, handleCampanha }: TItemLista) => {
    const [hideDisplay, setHideDisplay] = useState<boolean>(false);

    const formatarMoeda = (valor: number | null | undefined) =>
        typeof valor === 'number'
          ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor)
          : 'R$ 0,00';
      


    const camposHoraSede: CampoHoraSede<IHoraSedeCustomDTO>[] = [
        { key: 'id', label: 'ID' },
        { key: 'nomeHora', label: 'Tipo da Licença' },
        { key: 'horaUnidades', label: 'Unidades', render: (value) => formatarMoeda(value)  },
        { key: 'valorSugerido', label: 'Valor Sugerido', render: (value) => formatarMoeda(value)  },
        { key: 'numeroMaximoParcela', label: 'Nº Máx. Parcelas' },
        { key: 'numeroProrrogacaoDiasMatricula', label: 'Nº Pror.dias Matricula' },
        { key: 'splitUmHoraEMeia', label: 'Split Distrito 1h30', render: (value) => formatarMoeda(value) },
        { key: 'splitTresHoras', label: 'Split Distrito 3h' ,render: (value) => formatarMoeda(value) },
        { key: 'splitQuatroHorasEMeia', label: 'Split Distrito 4h30', render: (value) => formatarMoeda(value) },
        { key: 'splitSeisHoras', label: 'Split Distrito 6h' , render: (value) => formatarMoeda(value) },
        { key: 'splitAdicional', label: 'Split Distrito Adicional',  render: (value) => formatarMoeda(value)},
        { key: 'splitUmHoraEMeiaCapital', label: 'Split Capital 1h30' , render: (value) => formatarMoeda(value)},
        { key: 'splitTresHorasCapital', label: 'Split Capital 3h' , render: (value) => formatarMoeda(value)},
        { key: 'splitQuatroHorasEMeiaCapital', label: 'Split Capital 4h30' , render: (value) => formatarMoeda(value)},
        { key: 'splitSeisHorasCapital', label: 'Split Capital 6h', render: (value) => formatarMoeda(value) },
        { key: 'splitAdicionalCapital', label: 'Split Adicional Capital' ,render: (value) => formatarMoeda(value) },
        { key: 'flTaxa', label: 'Taxa', render: (value: boolean) => value ? 'Sim' : 'Não' },
        { key: 'valorSplitTaxa', label: 'Valor Taxa Split', render: (value) => formatarMoeda(value) },
        { key: 'splitColonia', label: 'Split Distrito Colônia', render: (value) => formatarMoeda(value) },
        { key: 'splitColoniaCapital', label: 'Split Colônia Capital' , render: (value) => formatarMoeda(value)},
        { key: 'splitEscola', label: 'Split Distrito Escola', render: (value) => formatarMoeda(value) },
        { key: 'splitEscolaCapital', label: 'Split Escola Capital' , render: (value) => formatarMoeda(value)},
        { key: 'splitCurta', label: 'Curta Distrito' ,render: (value) => formatarMoeda(value) },
        { key: 'splitCurtaUmHoraEMeia', label: 'Curta Distrito 1h30', render: (value) => formatarMoeda(value) },
        { key: 'splitCurtaTresHoras', label: 'Curta Distrito 3h', render: (value) => formatarMoeda(value) },
        { key: 'splitCurtaQuatroHorasEMeia', label: 'Curta Distrito 4h30',  render: (value) => formatarMoeda(value)},
        { key: 'splitCurtaSeisHoras', label: 'Curta Distrito 6h', render: (value) => formatarMoeda(value) },
        { key: 'splitCurtaMaiorSeisHoras', label: 'Curta Distrito > 6h', render: (value) => formatarMoeda(value) },
        { key: 'splitUpgradeUmaHoraEMeia', label: 'Upgrade Distrito 1h30' ,render: (value) => formatarMoeda(value) },
        { key: 'splitUpgradeTresHoras', label: 'Upgrade Distrito 3h', render: (value) => formatarMoeda(value) },
        { key: 'splitUpgradeQuatroHorasEMeia', label: 'Upgrade Distrito 4h30' ,render: (value) => formatarMoeda(value) },
        { key: 'splitUpgradeSeisHoras', label: 'Upgrade Distrito 6h', render: (value) => formatarMoeda(value) },
        { key: 'splitUpgradeMaiorSeisHoras', label: 'Upgrade Distrito > 6h' , render: (value) => formatarMoeda(value)},
        { key: 'splitAdicionalUpgrade', label: 'Upgrade Distrito Adicional', render: (value) => formatarMoeda(value) },
        { key: 'splitUpgradeUmaHoraEMeiaCapital', label: 'Upgrade Capital 1h30' , render: (value) => formatarMoeda(value)},
        { key: 'splitUpgradeTresHorasCapital', label: 'Upgrade Capital 3h', render: (value) => formatarMoeda(value) },
        { key: 'splitUpgradeQuatroHorasEMeiaCapital', label: 'Upgrade Capital 4h30', render: (value) => formatarMoeda(value) },
        { key: 'splitUpgradeSeisHorasCapital', label: 'Upgrade Capital 6h' ,render: (value) => formatarMoeda(value) },
        { key: 'splitUpgradeMaiorSeisHorasCapital', label: 'Upgrade Capital > 6h' ,render: (value) => formatarMoeda(value) },
        { key: 'splitAdicionalUpgradeCapital', label: 'Upgrade Adicional Capital' , render: (value) => formatarMoeda(value) },
        { key: 'dataCriacao', label: 'Data Split Gerado', render: (value: Date) => value ? new Date(value).toLocaleDateString('pt-BR') : '-' },
        { key: 'dataAtualizacao', label: 'Data Split Atualizada', render: (value: Date) => value ? new Date(value).toLocaleDateString('pt-BR') : '-' },
        { key: 'usuario', label: 'Usuário da Última Alteração' }
      ];
    
      const colunas = camposHoraSede.map(campo => ({
        key: campo.key,
        label: campo.label,
        render: campo.render,
        isLista: Array.isArray(hora?.[campo.key]),
      }));


    return (
        <div className="registro-user " style={{ display: 'flex' }} id="registro-financeiro">
            {colunas.map((coluna) => (
                <div className="item-body" key={coluna.key}>
                    {coluna.isLista ? (
                        <>
                            <span
                                onClick={() => setHideDisplay(!hideDisplay)}
                                style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }}
                            >
                                <span>Unidades</span>
                                <img
                                    className="config-icons-financeiro"
                                    src={info}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setHideDisplay(true);
                                    }}
                                />
                            </span>
                            {hideDisplay && (
                                <MsgInfoSistema
                                    setHideDisplay={setHideDisplay}
                                    hideDisplay={!hideDisplay}
                                    listTitle="Lista de unidades"
                                    listItem={(() => {
                                        const valor = hora[coluna.key];
                                        if (Array.isArray(valor) && valor.length > 0) {
                                            return valor.map((unidade: any) => unidade?.unidadeDescricao || "-");
                                        }
                                        return ["-"];
                                    })()}
                                />
                            )}
                        </>
                    ) : (

                        <span>
                            {coluna.key === 'id' ? (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span>{hora[coluna.key]}</span>
                                    {hora.ativo ? (
                                        <div className="estado-user">
                                            <div className="dot-verde"></div>
                                            <p className="ativo">Ativo</p>
                                        </div>
                                    ) : (
                                        <div className="estado-user">
                                            <div className="dot-vermelho"></div>
                                            <p className="inativo">Inativo</p>
                                        </div>
                                    )}
                                </div>

                            ) : (
                                <span>
                                {coluna.render
                                  ? coluna.render(hora[coluna.key], hora as IHoraSedeCustomDTO)

                                  : (hora[coluna.key] ?? "–")}
                              </span>
                              
                              
                            )}

                        </span>

                    )}
                </div>
            ))}
        </div>
    );

});

ItemListHoraSede.displayName = 'ItemListHoraSede';

export default ItemListHoraSede;

